import Spinner from 'react-bootstrap/Spinner';

function SpinnerLoading() {
  return <Spinner animation="grow" />;
}

export default SpinnerLoading;